import { type FC } from "react";

import { type MetricField } from "../../../gql-generated/types";
import { Flexbox } from "../../../shared/components";
import { useAudienceStats } from "../../hooks";
import { PieChartComponent } from "../charts";
import { HorizontalBarChart } from "../charts/horizontal-bar-chart";
import { ChartCard } from "../shared";

import { AgeChartComponent } from "./AgeChartComponent";
import { Container, flexChild, flexChildGrow, flexChildOneThird, row, twoLineHeader } from "./AudienceSection.styles";

interface AudienceSectionProps {
    baseMetricField: MetricField;
}

export const AudienceSection: FC<AudienceSectionProps> = ({ baseMetricField }) => {
    const { countryMetrics, interestMetrics, ageGenderMetrics, osMetrics, loading } = useAudienceStats(baseMetricField);

    return (
        <Container>
            <Flexbox className={row} alignItems="stretch">
                <ChartCard
                    className={`${flexChild} ${flexChildGrow} ${twoLineHeader}`}
                    title="Demographics"
                    subtitle="Learn about the age and gender breakdowns of your audience."
                >
                    <AgeChartComponent metrics={ageGenderMetrics} loading={loading} />
                </ChartCard>

                <ChartCard
                    className={`${flexChild} ${flexChildOneThird} ${twoLineHeader}`}
                    title="OS Breakdown"
                    subtitle="Learn about the operating system breakdown of your audience"
                >
                    <PieChartComponent metrics={osMetrics.stats} loading={loading} />
                </ChartCard>
            </Flexbox>

            <Flexbox className={row} alignItems="flex-start">
                <ChartCard
                    className={`${flexChild} ${twoLineHeader}`}
                    title="Top Countries"
                    subtitle="Learn about where your audience is located."
                >
                    <HorizontalBarChart loading={loading} stats={countryMetrics.stats} />
                </ChartCard>

                <ChartCard
                    className={`${flexChild} ${twoLineHeader}`}
                    title="Top Interests"
                    subtitle="Learn about the top interests of your audience."
                >
                    <HorizontalBarChart loading={loading} stats={interestMetrics.stats} />
                </ChartCard>
            </Flexbox>
        </Container>
    );
};
